__turbopack_context__.v({
  "chevronLeft": "NaturalLanguageSearch-module__nDqyKa__chevronLeft",
  "closeIcon": "NaturalLanguageSearch-module__nDqyKa__closeIcon",
  "does-not-exist": "NaturalLanguageSearch-module__nDqyKa__does-not-exist",
  "formInnerWrapper": "NaturalLanguageSearch-module__nDqyKa__formInnerWrapper",
  "input": "NaturalLanguageSearch-module__nDqyKa__input",
  "js-has-pseudo": "NaturalLanguageSearch-module__nDqyKa__js-has-pseudo",
  "overlayBackground": "NaturalLanguageSearch-module__nDqyKa__overlayBackground",
  "searchIcon": "NaturalLanguageSearch-module__nDqyKa__searchIcon",
  "spinnerIcon": "NaturalLanguageSearch-module__nDqyKa__spinnerIcon",
  "wrapper": "NaturalLanguageSearch-module__nDqyKa__wrapper",
});
